import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_overlay = _resolveComponent("v-overlay")!
  const _component_setting_card = _resolveComponent("setting-card")!

  return (_ctx.config)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_setting_card, _mergeProps(_ctx.binds, {
          active: _ctx.config.jeDeclareDotCom,
          "onUpdate:active": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.config.jeDeclareDotCom) = $event)),
          onUpdateProfile: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateProfile())),
          hidePrevious: true,
          hideMoreVert: true
        }), {
          default: _withCtx(() => [
            _createVNode(_component_v_container, { class: "px-6 pb-6" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, { class: "d-flex justify-center pb-2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "6" })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, { class: "d-flex justify-center pb-2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field_filled, {
                          modelValue: _ctx.config.jeDeclareDotComConfig.auth.username,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.config.jeDeclareDotComConfig.auth.username) = $event)),
                          "hide-details": "",
                          outlined: "",
                          autocomplete: "off",
                          label: "Login",
                          density: "compact"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, { class: "d-flex justify-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field_filled, {
                          modelValue: _ctx.config.jeDeclareDotComConfig.auth.password,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.config.jeDeclareDotComConfig.auth.password) = $event)),
                          "hide-details": "",
                          outlined: "",
                          autocomplete: "off",
                          type: "password",
                          label: "Mot de passe",
                          density: "compact"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, { class: "d-flex justify-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "text-red"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.JDCError), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_overlay, {
              absolute: true,
              "model-value": _ctx.JDCConnectionOnTest || _ctx.JDCConnectionTestSuccess
            }, {
              default: _withCtx(() => [
                (_ctx.JDCConnectionOnTest)
                  ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                      key: 0,
                      indeterminate: "",
                      color: "primary"
                    }))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (_ctx.JDCConnectionTestSuccess)
                        ? (_openBlock(), _createBlock(_component_v_icon, {
                            key: 0,
                            color: "secondary",
                            size: "x-large"
                          }, {
                            default: _withCtx(() => _cache[4] || (_cache[4] = [
                              _createTextVNode(" $fa-check ")
                            ])),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_v_icon, {
                            key: 1,
                            color: "error",
                            size: "x-large"
                          }, {
                            default: _withCtx(() => _cache[5] || (_cache[5] = [
                              _createTextVNode(" $fa-times ")
                            ])),
                            _: 1
                          }))
                    ], 64))
              ]),
              _: 1
            }, 8, ["model-value"])
          ]),
          _: 1
        }, 16, ["active"])
      ]))
    : _createCommentVNode("", true)
}